export const isChatWidgetAvailableSelector = (state) => Boolean(state.chatWidget?.isAvailable);
